import { useState, useEffect } from 'react';
import { Download, X } from 'lucide-react';

export default function InstallPrompt() {
  const [deferredPrompt, setDeferredPrompt] = useState(null);
  const [showPrompt, setShowPrompt] = useState(false);
  const [isIOS, setIsIOS] = useState(false);

  useEffect(() => {
    if (window.matchMedia('(display-mode: standalone)').matches) {
      return;
    }

    const dismissed = localStorage.getItem('pwaPromptDismissed');
    if (dismissed) {
      const dismissedTime = parseInt(dismissed, 10);
      if (Date.now() - dismissedTime < 7 * 24 * 60 * 60 * 1000) {
        return;
      }
    }

    const isIOSDevice = /iPad|iPhone|iPod/.test(navigator.userAgent) && !window.MSStream;
    setIsIOS(isIOSDevice);

    let timerId = null;

    if (isIOSDevice) {
      timerId = setTimeout(() => setShowPrompt(true), 3000);
      return () => clearTimeout(timerId);
    }

    const handler = (e) => {
      e.preventDefault();
      setDeferredPrompt(e);
      timerId = setTimeout(() => setShowPrompt(true), 2000);
    };

    window.addEventListener('beforeinstallprompt', handler);

    return () => {
      window.removeEventListener('beforeinstallprompt', handler);
      if (timerId) clearTimeout(timerId);
    };
  }, []);

  const handleInstall = async () => {
    if (!deferredPrompt) return;

    deferredPrompt.prompt();
    const { outcome } = await deferredPrompt.userChoice;

    if (outcome === 'accepted') {
      setShowPrompt(false);
    }
    setDeferredPrompt(null);
  };

  const handleDismiss = () => {
    setShowPrompt(false);
    localStorage.setItem('pwaPromptDismissed', Date.now().toString());
  };

  if (!showPrompt) return null;

  return (
    <div className="install-prompt">
      <div className="install-content">
        <Download size={24} className="install-icon" />
        <div className="install-text">
          <strong>Install TLC Checker</strong>
          {isIOS ? (
            <p>Tap <span className="ios-share">⎙</span> then "Add to Home Screen"</p>
          ) : (
            <p>Add to your home screen for quick access</p>
          )}
        </div>
      </div>
      <div className="install-actions">
        {!isIOS && (
          <button onClick={handleInstall} className="install-btn">
            Install
          </button>
        )}
        <button onClick={handleDismiss} className="dismiss-btn">
          <X size={18} />
        </button>
      </div>
    </div>
  );
}
